<template>
  <button
    type="button"
    :class="[
      $style.button,
      {
        [$style.active]: active,
        [$style.disabled]: disabled,
      },
    ]"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    active: Boolean,
    disabled: Boolean,
  },
};
</script>

<style lang="sass" module>
  .button
    +size(auto)
    +inline-flex
    background-color: transparent

    &.active
      background-color: #27283C

    &:disabled
      background-color: transparent
      color: rgba(255, 255, 255, 0.25)
      cursor: default
</style>
